import {createGlobalStyle} from 'styled-components';
import {Web3Provider} from '@ethersproject/providers'
import {Web3ReactProvider} from '@web3-react/core'
import Trias from './pages/Trias'
import Donate from './pages/Donate'
import TriasNFT from './pages/TriasNFT'
import Triasures from './pages/Triasures'
import AntiFraud from './pages/AntiFraud'
import ResearchAuction from './pages/ResearchAuction'
import NFTDetail from './pages/NFTDetail'
import {HashRouter, Route, Switch} from 'react-router-dom';
import Header from './components/common/Header'
import Footer from './components/common/Footer'
import {ContextProvider} from "./reducer";
import {InitPage} from "./pages/InitPage";

const getLibrary = (provider) => {
  const library = new Web3Provider(provider)
  library.pollingInterval = 8000
  return library
}

const GlobalStyle = createGlobalStyle`
html, body {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  background-color: #fff;
  color: #fff;
  font-family: Roboto,Helvetica Neue,Helvetica,Arial,Microsoft Yahei,Hiragino Sans GB,Heiti SC,WenQuanYi Micro Hei,sans-serif;
  font-weight: normal;
  font-size: 14px;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
a:hover {
  text-decoration: none;
}
.modal-dialog {
  font-size: 18px;
  color: #333;
}
.modal-dialog {
  margin-top: 120px;
  max-width: 600px;
  @media (max-width: 768px) {
    margin-top: 10%;
  } 
}
.modal-header, .modal-body {
  padding: 20px 30px;
}
.modal-body {
  line-height: 30px;
  padding-bottom: 40px;
}
.modal-body .form-label {
  font-size: 15px;
}
ul {
  list-style: none;
}
h1.h1 {
  font-size: 50px;
  font-weight: 500;
}
h2.h2 {
  font-size: 44px;
  font-weight: 500;
}
h3.h3 {
  font-size: 24px;
}
/* @media (max-width: 768px) {
  h1.h1 {
    font-size: 28px;
  }
} */
`

export default function App() {
  return (
      <ContextProvider>
        <Web3ReactProvider getLibrary={getLibrary}>
          <GlobalStyle/>
          <Header></Header>
          <InitPage />
          <HashRouter>
            <Switch>
              <Route exact path="/" component={Trias}/>
              <Route strict path="/donate" component={Donate}/>
              <Route strict path="/triasnft" component={TriasNFT}/>
              <Route strict path="/nftdetail" component={NFTDetail}/>
              <Route strict path="/triasures" component={Triasures}/>
              <Route strict path="/antifraud" component={AntiFraud}/>
              <Route strict path="/researchAuction" component={ResearchAuction}/>
            </Switch>
          </HashRouter>
          <Footer></Footer>
        </Web3ReactProvider>
      </ContextProvider>
  )
}
